
import { defineComponent, ref, watch } from "vue";
import InputComponent from "@/components/ui/InputComponent.vue";
import IconComponent from "@/components/ui/IconComponent.vue";
import TooltipComponent from "@/components/ui/TooltipComponent.vue";
import debounce from "lodash/debounce";
import { usePlace } from "@/modules/thuyloi/composables/usePlace";

export default defineComponent({
  name: "Nav",
  components: {
    InputComponent,
    IconComponent,
    TooltipComponent
  },
  props: {},
  setup() {
    const menuActive = ref(1);
    const places = ref([]);
    const searchValue = ref("");
    const isShow = ref(false);
    const { doSearchPlace, onFocusPlace } = usePlace();

    const onChangeSelect = (item: any) => {
      onFocusPlace.value = item;
      isShow.value = false;
    };

    const getData = async () => {
      const res = await doSearchPlace(searchValue.value);
      places.value = res.data;
      isShow.value = true;
    };

    const onClickOpenHome = async () => {
      window.open("/");
    };

    watch(
      searchValue,
      debounce((newVal: any) => {
        if (!newVal || newVal == "") {
          places.value = [];
        } else {
          getData();
        }
      }, 1000)
    );

    return {
      menuActive,
      places,
      isShow,
      searchValue,
      getData,
      onClickOpenHome,
      onChangeSelect
    };
  }
});
